export default __webpack_public_path__ + "static/media/iXperience.e808c1eb.png";